module.exports = __webpack_public_path__ + "static/media/52.0b7037e5.png";